import { goodsApi, channelApi, stockApi, orderApi, afterApi, purchaseApi, billApi } from '@/api';
import { GOODS_TYPES } from '@/utils/constants';
import { GOODS_COMBO_TYPES } from '@/utils/constants';
// spu

export function spuVirtual(title = 'SelectVirtualProductText', option) {
  return spuDefault(title, {
    defaultQuery: { type: GOODS_TYPES.VIRTUAL, status: 1 },
  });
}
export function spuReal(title = 'SelectPhysicalItemText', option) {
  return spuDefault(title, {
    defaultQuery: { type: GOODS_TYPES.REAL, status: 1 },
  });
}
export function spuPackage(title = 'SelectPackageProductText', option) {
  return spuDefault(title, {
    defaultQuery: { setFlag: GOODS_COMBO_TYPES.PACKAGE, status: 1 },
  });
}
export function spuOrdinary(title = 'SelectCommonProductText', option) {
  return spuDefault(title, {
    defaultQuery: { setFlag: GOODS_COMBO_TYPES.ORDINARY, status: 1 },
  });
}
export function spuDefault(title = 'SelectProductText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      // {
      //   prop: 'spuCode',
      //   label: 'goodsPage.spuCode',
      //   width: 160,
      // },
      // {
      //   prop: 'name',
      //   label: 'goodsPage.spuName',
      //   width: 160,
      // },
      {
        prop: 'categoryName',
        label: 'BjDialogListConfig.classification',
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.entercode',
        key: 'spuCode',
      },
      {
        placeholder: 'BjDialogListConfig.entername',
        key: 'name',
      },
      {
        placeholder: 'BjDialogListConfig.selectcategory',
        key: 'categoryIdList',
        component: 'BjGoodsTypeTreeSelect',
        multiple: true,
      },
    ],
    actionApi: option.actionApi || goodsApi.getPage,
    defaultQuery: option.defaultQuery || { status: 1 },
    query: option.query || '',
  };
}
// sku
export function skuReal(title = 'SelectPhysicalItemText', option) {
  return skuDefault(title, {
    defaultQuery: { spuType: GOODS_TYPES.REAL, status: [3, 4, 5] },
  });
}
export function skuDefault(title = 'SelectSKUText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      // {
      //   prop: 'categoryName',
      //   label: 'BjDialogListConfig.classification',
      // },
      // {
      //   prop: 'spuCode',
      //   label: 'goodsPage.spuCode',
      //   width: 160,
      // },
      // {
      //   prop: 'spuName',
      //   label: 'goodsPage.spuName',
      //   width: 160,
      // },
      {
        prop: 'skuName',
        label: 'BjDialogListConfig.SKUname',
        width: 160,
      },
      {
        prop: 'standardSkuCode',
        label: 'BjDialogListConfig.SKUcode',
        width: 160,
      },
    ],
    search: option.search || [
      // {
      //   placeholder: 'BjDialogListConfig.enterproductname',
      //   key: 'spuName',
      // },
      // {
      //   placeholder: 'BjDialogListConfig.enterproductcode',
      //   key: 'spuCode',
      // },
      // {
      //   placeholder: 'SalesOrderToBeApproved.Please',
      //   key: 'categoryName',
      // },
      {
        placeholder: 'BjDialogListConfig.SKUname',
        key: 'skuName',
      },
      {
        placeholder: 'BjDialogListConfig.SKUcode',
        key: 'skuCode',
      },
    ],
    actionApi: option.actionApi || goodsApi.getSku,
    defaultQuery: option.defaultQuery || { status: [3, 4, 5], itemType: "item", isHide:0, poSelect:true },
    query: option.query || '',
  };
}
// PO
export function POSelect(title = 'SelectPOText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'code',
        label: 'BjDialogListConfig.POCode',
        width: 160,
      },
      {
        prop: 'shippingMethod',
        label: 'BjDialogListConfig.POShippingMethod',
        width: 160,
      },
      {
        prop: 'containerId',
        label: 'BjDialogListConfig.POContainerId',
        width: 160,
      },
      {
        prop: 'status',
        label: 'BjDialogListConfig.POStatus',
        width: 160,
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.POCode',
        key: 'code',
      },
      {
        placeholder: 'BjDialogListConfig.POStatus',
        key: 'status',
        component: 'BjSelectLov',
        optionList: [
          {label: 'New', value: 'New'},
          {label: 'Uploaded', value: 'Uploaded'},
          {label: 'Arrived', value: 'Arrived'},
          {label: 'Receiving', value: 'Receiving'},
          {label: 'Received', value: 'Received'},
          {label: 'UploadFail', value: 'UploadFail'},
          {label: 'Done', value: 'Done'},
        ],
        colSpan: 8,
        multiple: true,
      },
      {
        placeholder: 'BjDialogListConfig.POShippingMethod',
        key: 'shippingMethod',
        component: 'BjSelectLov',
        optionList: [
          {value: 'Container', label: 'Container'},
          {value: 'Pallet', label: 'Pallet'},
          {value: 'Carton', label: 'Carton'},
        ],
      },
    ],
    defaultRequest: true,
    actionApi: option.actionApi || purchaseApi.getCsgPurchaseOrderList,
    defaultQuery: option.defaultQuery || { status: ["New","Uploaded","Arrived","Receiving","Received","UploadFail","Done"] },
    query: option.query || '',
  };
}
// Order 
export function OrderSelect(title = 'SelectOrderText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'webReference',
        label: 'BjDialogListConfig.Thirdordernumber',
        width: 160,
      },
      {
        prop: 'sapOrderNo',
        label: 'BjDialogListConfig.WMSOrderNo',
        width: 160,
      },
      {
        prop: 'totalOrderStatus',
        label: 'BjDialogListConfig.Orderstatus',
        width: 160,
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.orderNo',
        key: 'orderNo',
      },
      {
        placeholder: 'BjDialogListConfig.Orderstatus',
        key: 'totalOrderStatus',
        component: 'BjSelectLov',
        colSpan: 8,
        multiple: true,
        optionList: [
          {value: 1, label: 'OrderAllStatusNEWText'},
          {value: 2, label: 'OrderAllStatusErrorText'},
          {value: 3, label: 'OrderAllStatusProcessingText'},
          {value: 4, label: 'OrderAllStatusOutofStockText'},
          {value: 5, label: 'completedText'},
          {value: 6, label: 'canceledText'},
          {value: 7, label: 'OrderAllStatusCollectText'},
          {value: 8, label: 'BusinessAbnormalOrderWAIRING'},
        ],
      },
    ],
    defaultRequest: false,
    actionApi: option.actionApi || orderApi.getCSGThirdOrderPage,
    defaultQuery: option.defaultQuery,
    query: option.query || '',
  };
}
export function chargeItemDefault(title = 'route.BusinessBillingCategories', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'tag',
        label: 'billingPage.tag',
        width: 160,
      },
      {
        prop: 'billCategoryCode',
        label: 'billingPage.code',
        width: 160,
      },
      {
        prop: 'billCategoryName',
        label: 'billingPage.name',
        width: 160,
      },
    ],
    search: option.search || [],
    defaultRequest: true,
    actionApi: option.actionApi || billApi.getRpcBillCategoryList,
    defaultQuery: option.defaultQuery,
    query: option.query,
  };
}

// shop
export function shopDefault(title = 'SelectStoreText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'code',
        label: 'BjDialogListConfig.Storecode',
      },
      {
        prop: 'name',
        label: 'BjDialogListConfig.Storename',
      },
      {
        prop: 'categoryType',
        label: 'BjDialogListConfig.Storetype',
        constantKey: 'SHOP_TYPE_LIST',
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.entercode',
        key: 'code',
      },
      {
        placeholder: 'BjDialogListConfig.entername',
        key: 'name',
      },
    ],
    actionApi: option.actionApi || channelApi.getAllShopPage,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}
// shopOnline
export function shopOnline(title = 'SelectOnlineStoreText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'code',
        label: 'BjDialogListConfig.Codes',
      },
      {
        prop: 'name',
        label: 'BjDialogListConfig.Names',
      },
      {
        prop: 'channelTypeMeaning',
        label: 'BjDialogListConfig.Saleschannel',
      },
      {
        prop: 'onlineStoreTypeMeaning',
        label: 'BjDialogListConfig.Types',
      },
    ],

    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.enteronlinestorecode',
        key: 'code',
      },
      {
        placeholder: 'BjDialogListConfig.enteronlinestorename',
        key: 'name',
      },

      {
        placeholder: 'BjDialogListConfig.selectchannel',
        key: 'channelTypeCode',
        component: 'BjSelectLov',
        lovCode: 'SCHL.CHANNEL_TYPE',
      },
    ],
    actionApi: option.actionApi || channelApi.getOnlineShopPage,
    defaultQuery: option.defaultQuery || { status: true },
    query: option.query || '',
  };
}
// channelApi.getWarehousePage
export function warehouseDefault(title = 'SelectWarehouseText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'code',
        label: 'BjDialogListConfig.Warehousecode',
      },
      {
        prop: 'name',
        label: 'BjDialogListConfig.Warehousename',
      },
      {
        prop: 'detailAddress',
        label: 'BjDialogListConfig.Warehouseaddress',
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.Warehousecode',
        key: 'code',
      },
      {
        placeholder: 'BjDialogListConfig.Warehousename',
        key: 'name',
      },
    ],
    actionApi: option.actionApi || channelApi.getWarehousePage,
    //         // defaultQuery: { typeCode: ['real'] },
    defaultQuery: option.defaultQuery || { enableFlag: true },
    query: option.query || '',
  };
}
// stockApi.getWarehousesPage
export function stockWarehouseLogic(time, option) {
  return stockWarehouseDefault('SelectLogicalWarehouseText', {
    defaultQuery: { typeCode: ['logic'] },
  });
}
export function stockWarehouseReal(time, option) {
  return stockWarehouseDefault('SelectPhysicalWarehouseText', {
    defaultQuery: { typeCode: ['real'] },
  });
}
export function stockWarehouseDefault(title = 'SelectWarehouseText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'code',
        label: 'BjDialogListConfig.Warehousecode',
      },
      {
        prop: 'name',
        label: 'BjDialogListConfig.Warehousename',
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.Warehousecode',
        key: 'code',
      },
      {
        placeholder: 'BjDialogListConfig.Warehousename',
        key: 'name',
      },
    ],
    actionApi: option.actionApi || stockApi.getWarehousesPage,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}
// stockGoods
export function stockGoodsDefault(title = 'SelectProductText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      // {
      //   prop: 'spuCode',
      //   label: 'goodsPage.spuCode',
      //   width: 160,
      // },
      // {
      //   prop: 'spuName',
      //   label: 'goodsPage.spuName',
      //   width: 160,
      // },
      {
        prop: 'skuCode',
        label: 'BjDialogListConfig.SKUcode',
        width: 160,
      },
      {
        prop: 'categoryName',
        label: 'BjDialogListConfig.classification',
      },
      {
        prop: 'usableNum',
        label: 'BjDialogListConfig.Available',
      },
    ],
    search: option.search || [
      // {
      //   placeholder: 'BjDialogListConfig.enterproductname',
      //   key: 'spuName',
      // },
      // {
      //   placeholder: 'BjDialogListConfig.enterproductcode',
      //   key: 'spuCode',
      // },
      {
        placeholder: 'BjDialogListConfig.enterSKUcode',
        key: 'skuCode',
      },
    ],
    actionApi: option.actionApi || stockApi.getGoodsStockPage,
    // usableExcludeZeroFlag (boolean, optional): 可用库存是否大于零
    // warehouseId (Array[integer], optional): 仓库名称
    defaultQuery: option.defaultQuery || { warehouseId: [], usableExcludeZeroFlag: true },
    query: option.query || '',
  };
}

/** 内部销售单 */
export function innerOrderDefault(title = 'SelectSalesOrderText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'innerOrderNo',
        label: 'BjDialogListConfig.Internalordernumber',
        width: 160,
      },
      {
        prop: 'outerOrderNo',
        label: 'BjDialogListConfig.Thirdordernumber',
        width: 160,
      },
      {
        prop: 'businessType',
        label: 'BjDialogListConfig.Ordertype',
        constantKey: 'ORDER_BUSINESS_TYPE_LIST',
      },
      {
        prop: 'orderStatus',
        label: 'BjDialogListConfig.Orderstatus',
        constantKey: 'ORDER_INTERNAL_ORDER_STATUS_LIST',
      },
      {
        prop: 'storeName',
        label: 'BjDialogListConfig.Salesstore',
      },
      {
        prop: 'channelTypeMeaning',
        label: 'BjDialogListConfig.Saleschannel',
      },
      {
        prop: 'payStatus',
        label: 'BjDialogListConfig.Paymentstatus',
        constantKey: 'ORDER_INTERNAL_PAYMENT_STATUS_LIST',
      },
      {
        prop: 'goodsQuatity',
        label: 'BjDialogListConfig.Itemquantity',
      },
      {
        prop: 'totalAmount',
        label: 'BjDialogListConfig.goodsamount',
      },
      {
        prop: 'buyerPay',
        label: 'BjDialogListConfig.Buyerpayable',
      },
      {
        prop: 'costPrice',
        label: 'BjDialogListConfig.goodscost',
      },
      {
        prop: 'buyerRealPrice',
        label: 'BjDialogListConfig.Buyerpayment',
      },
      {
        prop: 'deliveryStatus',
        label: 'BjDialogListConfig.Shipmentstatus',
        constantKey: 'ORDER_INTERNAL_DELIVER_STATUS_LIST',
        width: 100,
      },
      {
        prop: 'receivingStatus',
        label: 'BjDialogListConfig.Receivingstatus',
        constantKey: 'ORDER_INTERNAL_RECEIVING_STATUS_LIST',
        width: 100,
      },
      {
        prop: 'buyerNick',
        label: 'BjDialogListConfig.Buyernickname',
      },
      {
        prop: 'receiverName',
        label: 'BjDialogListConfig.Consigneename',
      },
      {
        prop: 'mobile',
        label: 'BjDialogListConfig.Phone',
        width: 100,
      },
      {
        prop: 'address',
        label: 'BjDialogListConfig.Shippingaddress',
      },
      {
        prop: 'orderTime',
        label: 'BjDialogListConfig.Threepartyorder',
        width: 135,
      },
      {
        prop: 'payTime',
        label: 'BjDialogListConfig.Paymenttime',
        width: 135,
      },
      {
        prop: 'creationDate',
        label: 'BjDialogListConfig.Creationtime',
        width: 135,
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.Tripartitenumber',
        key: 'orderNo',
      },
    ],
    showChannelStore: ['channel', 'storeIdList'],
    actionApi: option.actionApi || orderApi.getInternalPage,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}
/** 退款商品 */
export function refundGoodsDefault(title = 'SelectRefundProductText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      // {
      //   prop: 'spuCode',
      //   label: 'goodsPage.spuCode',
      //   width: 160,
      // },
      // {
      //   prop: 'spuName',
      //   label: 'goodsPage.spuName',
      //   width: 160,
      // },
      {
        prop: 'skuCode',
        label: 'BjDialogListConfig.SKUcode',
        width: 160,
      },
      {
        prop: 'skuName',
        label: 'BjDialogListConfig.SKUname',
        width: 160,
      },
      {
        prop: 'giftFlag',
        label: 'BjDialogListConfig.giftor',
        constantKey: 'STATUS_YES_NUM',
        width: 80,
      },
      {
        prop: 'totalQuantity',
        label: 'BjDialogListConfig.Itemquantity',
        width: 80,
      },
    ],
    search: option.search || [],
    actionApi: option.actionApi || afterApi.getRefundPageByInnerNo,
    defaultQuery: option.defaultQuery || { innerOrderNo: null },
    query: option.query || '',
  };
}

/** 三方销售单 */
export function thirdOrderDefault(title = 'SelectThirdPartyOrderText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'webReference',
        label: 'BjDialogListConfig.Thirdordernumber',
        width: 160,
      },
      {
        prop: 'sapOrderNo',
        label: 'BjDialogListConfig.TripartiteId',
        width: 160,
      },
      {
        prop: 'cusId',
        label: 'billingPage.CustomerName',
        width: 160,
      },
      // {
      //   prop: 'innerOrderNo',
      //   label: 'BjDialogListConfig.Internalordernumber',
      //   width: 160,
      // },
      // {
      //   prop: 'businessType',
      //   label: 'BjDialogListConfig.Ordertype',
      //   constantKey: 'ORDER_BUSINESS_TYPE_LIST',
      // },
      {
        prop: 'channelTypeMeaning',
        label: 'BjDialogListConfig.Saleschannel',
      },
      {
        prop: 'storeName',
        label: 'BjDialogListConfig.Salesstore',
        width: 160,
      },
      {
        prop: 'circulationStatus',
        label: 'BjDialogListConfig.Circulationstatus',
        constantKey: 'AFTER_THIRD_REFUND_TRANSFER_STATUS',
      },
      // {
      //   prop: 'syncStatus',
      //   label: 'BjDialogListConfig.Writestatus',
      //   constantKey: 'ORDER_BACK_RES_LIST',
      // },
      // {
      //   prop: 'receivingStatus',
      //   label: 'BjDialogListConfig.Platformstatus',
      //   constantKey: 'ORDER_THIRD_RECEIVING_STATUS_LIST',
      // },
      // {
      //   prop: 'goodsQuantity',
      //   label: 'BjDialogListConfig.itemsNumber',
      // },
      // {
      //   prop: 'goodsTotalAmount',
      //   label: 'BjDialogListConfig.goodsamount',
      // },
      // {
      //   prop: 'totalDiscount',
      //   label: 'BjDialogListConfig.Discounttotal',
      // },
      // {
      //   prop: 'amountReceivable',
      //   label: 'BjDialogListConfig.Totalamount',
      // },
      // {
      //   prop: 'buyerPayAmount',
      //   label: 'BjDialogListConfig.Buyerpayment',
      // },
      // {
      //   prop: 'businessDiscountAmount',
      //   label: 'BjDialogListConfig.Merchantamount',
      // },
      // {
      //   prop: 'thirdDiscountAmount',
      //   label: 'BjDialogListConfig.preferentialamount',
      // },
      // {
      //   prop: 'buyerNick',
      //   label: 'BjDialogListConfig.Buyernickname',
      // },
      // {
      //   prop: 'receiverName',
      //   label: 'BjDialogListConfig.Consigneename',
      // },

      // {
      //   prop: 'mobile',
      //   label: 'BjDialogListConfig.Phone',
      //   width: 100,
      // },
      // {
      //   prop: 'orderTime',
      //   label: 'BjDialogListConfig.Threepartyorder',
      //   width: 135,
      // },
      {
        prop: 'payTime',
        label: 'BjDialogListConfig.Paymenttime',
        width: 135,
      },
      {
        prop: 'creationDate',
        label: 'BjDialogListConfig.Orderpulling',
        width: 135,
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.TripartiteId',
        key: 'orderNo',
      },
    ],
    showChannelStore: ['channel', 'storeIdList'],
    actionApi: option.actionApi || orderApi.getCSGThirdOrderPage,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}
/** 三方退款商品： 三方销售单详情的thirdItemVO字段 */
export function thirdRefundGoodsDefault(title = 'SelectRefundProductText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      // {
      //   prop: 'spuCode',
      //   label: 'goodsPage.spuCode',
      //   width: 160,
      // },
      // {
      //   prop: 'spuName',
      //   label: 'goodsPage.spuName',
      //   width: 160,
      // },
      {
        prop: 'skuCode',
        label: 'BjDialogListConfig.SKUcode',
        width: 160,
      },
      {
        prop: 'skuName',
        label: 'BjDialogListConfig.SKUname',
      },
      {
        prop: 'quantity',
        label: 'BjDialogListConfig.Itemquantity',
      },
    ],
    search: option.search || [],
    actionApi: option.actionApi || afterApi.getRefundPageByInnerNo,
    defaultQuery: option.defaultQuery || { innerOrderNo: null },
    query: option.query || '',
  };
}

export const purchaseDefaultColumns = [
  {
    prop: 'supplierCode',
    label: 'BjDialogListConfig.Suppliercode',
    width: 160,
  },
  {
    prop: 'supplierName',
    label: 'BjDialogListConfig.Suppliername',
    width: 160,
  },
  // {
  //   prop: 'spuCode',
  //   label: 'goodsPage.spuCode',
  //   width: 160,
  // },
  // {
  //   prop: 'spuName',
  //   label: 'goodsPage.spuName',
  //   width: 160,
  // },
  {
    prop: 'skuCode',
    label: 'BjDialogListConfig.SKUcode',
    width: 160,
  },
  {
    prop: 'skuName',
    label: 'BjDialogListConfig.SKUname',
  },
  {
    prop: 'supplierSpuCode',
    label: 'BjDialogListConfig.Suppliercommodity',
  },
  {
    prop: 'taxUnitPrice',
    label: 'BjDialogListConfig.Pricetax',
  },
  {
    prop: 'taxRate',
    label: 'BjDialogListConfig.Taxrate',
    after: '%',
  },
];
export const purchaseDefaultSearch = [
  {
    placeholder: 'BjDialogListConfig.entersuppliercode',
    key: 'supplierCode',
  },
  {
    placeholder: 'BjDialogListConfig.entersuppliername',
    key: 'supplierName',
  },
  // {
  //   placeholder: 'BjDialogListConfig.enterproductname',
  //   key: 'spuName',
  // },
  // {
  //   placeholder: 'BjDialogListConfig.enterproductcode',
  //   key: 'spuCode',
  // },
  {
    placeholder: 'BjDialogListConfig.enterSKUcode',
    key: 'skuCode',
  },
];
/** 供应商商品 */
export function purchaseGoodsDefault(title = 'SelectSupplierProductText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      ...purchaseDefaultColumns,
      {
        prop: '',
        label: 'BjDialogListConfig.Available',
      },
      {
        prop: '',
        label: 'BjDialogListConfig.Number',
      },
      {
        prop: 'minQty',
        label: 'BjDialogListConfig.Minimum',
      },
    ],
    search: option.search || purchaseDefaultSearch,
    actionApi: option.actionApi || purchaseApi.getSupplierGoodss,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}
/** 采购单 */
export function purchaseOrderDefault(title = 'SelectPurchaseOrderText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'code',
        label: 'BjDialogListConfig.Purchaseorder',
      },
      {
        prop: 'typeMeaning',
        label: 'BjDialogListConfig.Purchasetype',
      },
      {
        prop: 'statusMeaning',
        label: 'BjDialogListConfig.Orderstatus',
      },
      {
        prop: 'stockinStatusMeaning',
        label: 'BjDialogListConfig.Warehousingstatus',
      },
      // {
      //   prop: 'warehouseName',
      //   label: 'BjDialogListConfig.Receivingwarehouse',
      // },
      {
        prop: 'supplierName',
        label: 'BjDialogListConfig.Suppliername',
      },
      {
        prop: 'creationDate',
        label: 'BjDialogListConfig.Creationtime',
      },
      {
        prop: 'planQty',
        label: 'BjDialogListConfig.Purchasequantity',
      },
      {
        prop: 'alreadyQty',
        label: 'BjDialogListConfig.Receiptquantity',
      },
      {
        prop: 'waitQty',
        label: 'BjDialogListConfig.Quantityreceived',
      },
      {
        prop: 'cancelQty',
        label: 'BjDialogListConfig.Stopwaiting',
      },
    ],
    search: option.search || [
      {
        placeholder: 'BjDialogListConfig.Purchaseorder',
        key: 'code',
      },
      {
        placeholder: 'BjDialogListConfig.Suppliername',
        key: 'supplier',
      },
      {
        placeholder: 'BjDialogListConfig.SKUcode',
        key: 'skuCode',
      },
    ],
    actionApi: option.actionApi || purchaseApi.getPurchases,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}

export const logDefaultColumns = [
  {
    prop: 'creationDate',
    label: 'BjDialogListConfig.Operationtime',
  },
  {
    prop: 'createdName',
    label: 'BjDialogListConfig.Operator',
  },
  // {
  //   prop: 'actionTypeMeaning',
  //   label: 'BjDialogListConfig.Operationtype',
  // },
  {
    prop: 'remark',
    label: 'BjDialogListConfig.Remarks',
  },
];
export function orderLogDefault(title = 'OrderLogText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'creationDate',
        label: 'BjDialogListConfig.Operationtime',
      },
      {
        prop: 'createdName',
        label: 'BjDialogListConfig.Operator',
      },
      // {
      //   prop: 'actionTypeMeaning',
      //   label: 'BjDialogListConfig.Operationtype',
      // },
      {
        prop: 'message',
        label: 'BjDialogListConfig.Remarks',
      },
    ],
    search: option.search || [],
    actionApi: option.actionApi || orderApi.getLogPage,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}

export function purchaseDefault(title = 'SupplierLogText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'creationDate',
        label: 'BjDialogListConfig.Operationtime',
      },
      {
        prop: 'operateName',
        label: 'BjDialogListConfig.Operator',
      },
      // {
      //   prop: 'actionMeaning',
      //   label: 'BjDialogListConfig.Operationtype',
      // },
      {
        prop: 'remark',
        label: 'BjDialogListConfig.Remarks',
      },
    ],
    search: option.search || [],
    actionApi: option.actionApi || purchaseApi.getPurchaseLog,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}

export function commonDefault(title = 'logText', option = {}) {
  return {
    title: title,
    columns: option.columns || logDefaultColumns,
    search: option.search || [],
    actionApi: option.actionApi,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}


export function packageDefault(title = 'SelectThirdPartyOrderText', option = {}) {
  return {
    title: title,
    columns: option.columns || [
      {
        prop: 'skuName',
        label: 'goodsPage.package.Name',
      },
      {
        prop: 'skuCode',
        label: 'goodsPage.package.SKU',
      },
      {
        prop: 'barCode',
        label: 'goodsPage.package.Barcode',
      },
      // {
      //   prop: 'packingMethod',
      //   label: 'goodsPage.package.Method',
      //   constantKey: 'PACKAGE_TYPE_LIST',
      // },
    ],
    search: option.search || [
      {
        placeholder: 'goodsPage.package.Name',
        key: 'skuName',
      },
      // {
      //   placeholder: 'goodsPage.package.Method',
      //   key: 'packingMethod',
      //   component: 'BjSelectLov',
      //   optionList: [
      //     { label: 'goodsPage.package.order', value: 'order' },
      //     { label: 'goodsPage.package.product', value: 'product' },
      //   ],
      // },
    ],
    actionApi: option.actionApi || goodsApi.getSkuPage,
    defaultQuery: option.defaultQuery || {},
    query: option.query || '',
  };
}